module.exports = __webpack_public_path__ + "img/sun-rise.dc2d8913.svg";